import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiUserPlus, FiPackage, FiTrendingUp, FiTruck, FiCheckCircle, FiHeadphones } from 'react-icons/fi';
import "../../../../assets/css/customer/subscreens/home/Sellerbanner.css";

const SellerBanner = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const benefits = [
    {
      id: 1,
      icon: <FiUserPlus />,
      title: 'NO SETUP FEE',
      subtitle: 'Start Selling for Free'
    },
    {
      id: 2,
      icon: <FiPackage />,
      title: 'FREE LISTING',
      subtitle: 'Unlimited Products'
    },
    {
      id: 3,
      icon: <FiTrendingUp />,
      title: 'MARKETING SUPPORT',
      subtitle: 'Share Your Creativity'
    },
    {
      id: 4,
      icon: <FiTruck />,
      title: 'CASH ON DELIVERY',
      subtitle: 'Easy COD Order Handling'
    },
    {
      id: 5,
      icon: <FiCheckCircle />,
      title: 'VERIFIED BUYERS',
      subtitle: 'Build Trust With Customers'
    },
    {
      id: 6,
      icon: <FiHeadphones />,
      title: 'DEDICATED SUPPORT',
      subtitle: 'Quick Help Support'
    }
  ];

  // Scroll animation trigger
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Navigate to Seller Signup Page
  const handleBecomeSellerClick = () => {
    navigate('/seller/signup');
  };

  return (
    <section 
      ref={sectionRef}
      className={`seller-banner-section ${isVisible ? 'section-visible' : ''}`}
    >
      <div className="seller-banner-background">
        <div className="seller-banner-overlay"></div>
        <Container className="seller-banner-container">
          <Row className="align-items-center seller-banner-row">
            {/* Left Side - Text & Button */}
            <Col lg={5} md={12} className="seller-text-col">
              <div className="seller-text-content">
                <h1 className="seller-heading">
                  Start Selling Your <span className="highlight-text">Handmade Products</span> 
                </h1>
                <p className="seller-subheading">
                  Join our marketplace and reach thousands of customers looking for unique handmade treasures
                </p>
                <button 
                  className="btn-become-seller"
                  onClick={handleBecomeSellerClick}
                >
                 Register Now
                </button>
              </div>
            </Col>

            {/* Right Side - Benefits Card */}
            <Col lg={7} md={12} className="seller-benefits-col">
              <div className="benefits-card">
                {/* Heading with orange underline */}
                <div className="benefits-card-header">
                  <h2 className="benefits-heading">
                    SELLER BENEFITS
                  </h2>
                </div>
                
                {/* Benefits Grid */}
                <div className="benefits-grid">
                  {benefits.map((benefit) => (
                    <div 
                      key={benefit.id} 
                      className="benefit-item"
                    >
                      <div className="benefit-circle">
                        <div className="benefit-icon">
                          {benefit.icon}
                        </div>
                      </div>
                      <h4 className="benefit-title">{benefit.title}</h4>
                      <p className="benefit-subtitle">{benefit.subtitle}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default SellerBanner;